import { z } from 'zod';

import { unique } from '@vestigas/utils';

export const zodTaxCodeFilterOptionsQueryParamsSchema = z.object({
  companyIds: z
    .array(z.uuid())
    .optional()
    .catch(undefined)
    .transform((values) =>
      values ? unique(values).filter(Boolean).toSorted() : values,
    ),
});

export const zodTaxCodeFilterOptionsResponseSchema = z.object({
  codes: z.array(z.string()),
  names: z.array(z.string()),
  rates: z.array(z.string()),
});
